import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BookingService } from '@clooper/core';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-cancel-booking',
  templateUrl: './cancel-booking.component.html',
  styleUrls: ['./cancel-booking.component.scss']
})
export class CancelBookingComponent implements OnInit {
  step1 = true;
  showNextDisplay = false;
  icons = {
    cancel: faTimes
  }
  cancelForm: FormGroup;
  cancelRequestSent: boolean = false;
  id: any;
  loading = false;

  constructor(
    public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private booking: BookingService,
    private router: ActivatedRoute,
    public options: ModalOptions

  ) { 

    this.id = this.options?.initialState?.id
  }

  ngOnInit(): void {
    console.log(this.options)
    console.log(this.id)
    this.cancelForm = this.fb.group({
      message : ['', Validators.required]
    })
  }


  showNext() {
    this.step1 = false
    this.showNextDisplay = true;
  }

  submitCancellation() {
    console.log(this.cancelForm.value)
    this.loading = true;

    this.booking.cancelUserBooking(this.id, this.cancelForm.value).subscribe((res: any) => {
      console.log('dsdsd', res)
      this.loading = false
      if (res) {

        this.cancelRequestSent = true;
        this.showNextDisplay = false
        this.step1 = false
      }
    })
  }

}
